import {configureStore} from '@reduxjs/toolkit'
import {useDispatch, useSelector} from 'react-redux'
import {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import {commonSliceReducer} from '@/store/slices/commonSlice'
import themeReducer from './slices/themeSlice'
import countryCodeReducer from './slices/countryCodeSlice'
import {salesTargetSliceReducer} from '@/store/slices/salesTargetSlice'
import {activitySliceReducer} from '@/store/slices/activitySlice'
import {pointMultiplierSliceReducer} from '@/store/slices/pointMultiplier'
import {bulkModifiersSliceReducer} from '@/store/slices/bulkPointSlice'
import {userDetailsSliceReducer} from '@/store/slices/userSlice'
import {productReviewSliceReducer} from '@/store/slices/productReviewSlice'
import rewardsReducer from '@/store/slices/rewardsSlice'
import rewardBulkUploadReducer from '@/store/slices/rewardBulkUpload'

// Persist configuration for activity reducer
const activityPersistConfig = {
  key: 'activity',
  storage,
  whitelist: ['activity'], // only activity will be persisted
}

const pointMultiplierConfig = {
  key: 'pointMultiplier',
  storage,
  whitelist: ['pointMultiplier'], // only activity will be persisted
}

// Persist configuration for sales target reducer
const salesTargetPersistConfig = {
  key: 'salesTarget',
  storage,
  whitelist: ['salesTarget'], // only salesTarget will be persisted
}

const productReviewPersistConfig = {
  key: 'productReview',
  storage,
  whitelist: ['productReview'], // Only productReview will be persisted
}

// Create persisted activity reducer
const persistedActivityReducer = persistReducer(activityPersistConfig, activitySliceReducer)

// Create persisted point mutliplier reducer
const persistedPointMultiplierReducer = persistReducer(pointMultiplierConfig, pointMultiplierSliceReducer)
// Create persisted sales target reducer
const persistedSalesTargetReducer = persistReducer(salesTargetPersistConfig, salesTargetSliceReducer)

// Create persisted product review reducer
const persistedProductReviewReducer = persistReducer(productReviewPersistConfig, productReviewSliceReducer)

export const reducers = {
  common: commonSliceReducer,
  theme: themeReducer,
  countryCode: countryCodeReducer,
  salesTarget: persistedSalesTargetReducer,
  activity: persistedActivityReducer,
  bulkModifiers: bulkModifiersSliceReducer,
  userDetails: userDetailsSliceReducer,
  productReview: persistedProductReviewReducer,
  pointMultiplier: persistedPointMultiplierReducer,
  rewards: rewardsReducer,
  rewardBulkUpload: rewardBulkUploadReducer,
}

export const store = configureStore({
  reducer: reducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'], // Ignore persist actions
      },
    }),
})

export const useAppDispatch = () => useDispatch()
export const useAppSelector = useSelector
export const persistor = persistStore(store)
